import Modal from "../../components/Misc/Modal";
import { Icon } from "@iconify/react";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import OrderSearchModalContent from "./Modalcontents/OrderSearchModalContent";
import OrderCreateModalContent from "./Modalcontents/OrderCreateModalContent";
import { useDispatch } from "react-redux";
import { setLoading, updateOrderData } from "../../redux/actions";
import { searchOrder } from "../../service";

const OrderHeader = ({ paginationModel }) => {
  const [show, setShow] = useState({
    search: false,
    purchases: false,
    create: false,
  });
  const isInitialRender = useRef(true);
  const { page, pageSize } = paginationModel;
  const [formData, setData] = useState({
    limit: pageSize,
    pageNumber: page,
  });

  const onChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const showModal = (key) => {
    setShow({ ...show, [key]: true });
  };

  const hideModal = (key) => {
    setShow({ ...show, [key]: false });
  };

  useEffect(() => {
    if (!isInitialRender.current) {
      searchOrders();
    } else {
      isInitialRender.current = false;
    }
  }, [page, pageSize]);
  const dispatch = useDispatch();

  const searchOrders = async () => {
    hideModal("search");
    dispatch(setLoading({stat: true, text: 'Searching Orders'}));
    const { count, data } = await searchOrder({
      ...formData,
      limit: pageSize,
      pageNumber: page,
    });
    dispatch(updateOrderData({ count, orders: data }));
    dispatch(setLoading(false));
  };

  return (
    <div className="flex items-center">
      <p className="text-lg font-500 font-semibold">Orders</p>
      <Link
        to="#"
        onClick={() => showModal("search")}
        className="inline-flex items-center justify-center gap-2.5 rounded-full bg-black py-2 px-5 text-center font-medium text-white hover:bg-opacity-90 ml-auto"
      >
        <Icon icon="material-symbols:download-sharp" /> Search Orders
      </Link>
      <Link
        to="#"
        onClick={() => showModal("purchases")}
        className="inline-flex items-center justify-center gap-2.5 rounded-full bg-black py-2 px-5 text-center font-medium text-white hover:bg-opacity-90 ml-4"
      >
        <Icon icon="material-symbols:download-sharp" /> Purchases
      </Link>
      <Link
        to="#"
        onClick={() => showModal("create")}
        className="inline-flex items-center justify-center gap-2.5 rounded-full bg-black py-2 px-5 text-center font-medium text-white hover:bg-opacity-90 ml-4"
      >
        <Icon icon="material-symbols:group-add-outline" /> Create
      </Link>
      <Modal show={show.search || show.create}>
        {show.search ? (
          <OrderSearchModalContent
            onChange={onChange}
            formData={formData}
            onSubmit={searchOrders}
            onCancel={() => hideModal("search")}
          />
        ) : (
          <OrderCreateModalContent onCancel={() => hideModal("create")} />
        )}
      </Modal>
    </div>
  );
};

export default OrderHeader;
